"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: -10%;\n  right: -10%;\n  width: 50%;\n  height: auto;\n  aspect-ratio: 1;\n  border-radius: 200px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AntiIcon = void 0;

var react_1 = __importDefault(require("react"));

var icons_1 = require("../icons");

var styled_1 = require("./styled");

var theme_1 = require("./theme");

function AntiIcon(_ref) {
  var children = _ref.children,
      color = _ref.color,
      icon = _ref.icon;
  var iconProps = {
    width: '90%',
    height: '90%',
    color: 'white'
  };
  return react_1.default.createElement(Container, null, children, react_1.default.createElement(IconContainer, {
    color: color
  }, icon ? react_1.default.cloneElement(icon, iconProps) : react_1.default.createElement(icons_1.Cancel, Object.assign({}, iconProps))));
}

exports.AntiIcon = AntiIcon;
var Container = (0, styled_1.styledContainer)(_templateObject());
var IconContainer = (0, styled_1.styledContainer)(_templateObject2(), function (props) {
  return (0, theme_1.getColor)(props.theme, props.color || '@red');
});